import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';
import { EntityState } from 'app/projects/entity/src/lib/models/entity.state';
import { SetUserCourseCertificates } from '../actions';
import { CertificateRecord } from './certificate-record';
import { UserCourseCertificateStateModel } from './user-course-certificate.state-model';

@State<UserCourseCertificateStateModel>({
    name: 'userCourseCertificate',
    defaults: new UserCourseCertificateStateModel(),
})
@Injectable()
export class UserCourseCertificateState extends EntityState<CertificateRecord> {
    @Selector()
    static getEntity(state: UserCourseCertificateStateModel, id: string = state.item): CertificateRecord {
        if (!state.map) {
            return null;
        }

        return state.map.get(id) || null;
    }

    @Selector()
    static getEntities(state: UserCourseCertificateStateModel): CertificateRecord[] {
        if (!state.map) {
            return null;
        }

        return Array.from(state.map.values());
    }

    constructor() {
        super(null, 30);
    }

    @Action(SetUserCourseCertificates)
    setEntities(ctx: StateContext<UserCourseCertificateStateModel>, action: SetUserCourseCertificates): void {
        this._setEntities(ctx, action);
    }
}
